<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 52 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_205_2)">
      <path
        d="M4.08356 28.215L9.29311 10.0472L12.771 11.0444L16.8288 26.0835L14.9861 25.5551L26.2671 14.9144L29.719 15.9042L24.5613 34.0869L20.6163 32.9557L24.0659 20.8277L24.7926 21.0361L15.7945 29.4945L13.8999 28.9513L10.6217 16.9726L11.5041 17.2257L8.02858 29.3462L4.08356 28.215Z"
        fill="#D1D5DB"
      />
    </g>
    <g filter="url(#filter1_d_205_2)">
      <path
        d="M27.5485 33.8378L22.1133 13.5534L31.3282 11.0843C33.5305 10.4942 35.5859 10.3989 37.4944 10.7986C39.3977 11.179 41.0245 11.9957 42.3749 13.2489C43.7252 14.5021 44.6774 16.1623 45.2312 18.2294C45.7799 20.2771 45.7854 22.1909 45.2478 23.9707C44.7049 25.7312 43.707 27.2616 42.2541 28.562C40.7959 29.843 38.9657 30.7786 36.7634 31.3687L27.5485 33.8378ZM31.2102 28.7259L35.4989 27.5768C36.8512 27.2144 37.9527 26.6501 38.8033 25.8839C39.6681 25.0931 40.2442 24.1519 40.5315 23.0604C40.838 21.9637 40.8205 20.7778 40.4789 19.5028C40.1321 18.2084 39.5543 17.1727 38.7456 16.3955C37.951 15.5938 36.9842 15.0764 35.845 14.8433C34.72 14.5857 33.4814 14.6381 32.1291 15.0004L27.8404 16.1496L31.2102 28.7259Z"
        fill="#1E90FF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_205_2"
        x="0.0836182"
        y="10.0471"
        width="33.6873"
        height="32.0398"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_205_2"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_205_2"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_205_2"
        x="18.1133"
        y="8.08716"
        width="33.8356"
        height="33.7507"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_205_2"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_205_2"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
